"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertChecksLedger = exports.loadbalance = exports.shouldHideStartBalanceAdjustment = exports.replacementOrder = exports.firstDate = exports.updateLedgerFlag = exports.insertfeesledger = exports.deletenullledger = exports.adjustledger = exports.ledgerReport = exports.startbalanceledger = exports.orderledger = exports.saveLedgerItems = void 0;
const permissions_1 = require("shared/permissions");
const endpoint_1 = require("api/endpoint");
exports.saveLedgerItems = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/saveledger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.orderledger = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/orderledger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.startbalanceledger = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/startbalanceledger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.ledgerReport = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/ledger-report",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.adjustledger = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/adjust-ledger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.deletenullledger = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/delete-null-ledger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.insertfeesledger = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/eobfees-ledger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updateLedgerFlag = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/update-ledgerFlag",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.firstDate = endpoint_1.createEndpoint()({
    method: "get",
    path: "ledger/ledger-first-date",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.replacementOrder = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/replacement-order",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.shouldHideStartBalanceAdjustment = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/ledger-starting-balance-adjustment",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.loadbalance = endpoint_1.createEndpoint()({
    method: "get",
    path: "eob/eobchecks/loadbalance",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.insertChecksLedger = endpoint_1.createEndpoint()({
    method: "post",
    path: "ledger/checks-ledger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});



//////////////////
// WEBPACK FOOTER
// ./src/api/ledger/ledger-client.ts
// module id = 989
// module chunks = 0 1 2